// reducer.ts - Make sure this is correct
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginState {
    user: any;
    error: string;
    success: boolean;
    isUserLogout: boolean;
    loading: boolean;
}

const initialState: LoginState = {
    user: null,
    error: "",
    success: false,
    isUserLogout: false,
    loading: false
};

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        loginSuccess(state: LoginState, action: PayloadAction<any>) {
            console.log("loginSuccess reducer called with:", action.payload); // Debug
            state.user = action.payload;
            state.success = true;
            state.loading = false;
            state.error = "";
        },
        loginError(state: LoginState, action: PayloadAction<string>) {
            console.log("loginError reducer called with:", action.payload); // Debug
            state.error = action.payload;
            state.success = false;
            state.loading = false;
            state.user = null;
        },
        logoutSuccess(state: LoginState, action: PayloadAction<boolean>) {
            state.isUserLogout = action.payload;
            state.user = null;
            state.success = false;
            state.error = "";
        }
    },
});

export const { loginSuccess, loginError, logoutSuccess } = loginSlice.actions;
export default loginSlice.reducer;